<template>
  <div id="app" class="body-container">
    <keep-alive>
      <router-view v-wechat-title="$route.meta.title" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-wechat-title="$route.meta.title" v-if="!$route.meta.keepAlive"></router-view>
    <div v-show="loading" class="lz-readys" id="lz-readys">
      <div class="spinner">
        <div class="spinner-container container1">
          <div class="circle1"></div>
          <div class="circle2"></div>
          <div class="circle3"></div>
          <div class="circle4"></div>
        </div>
        <div class="spinner-container container2">
          <div class="circle1"></div>
          <div class="circle2"></div>
          <div class="circle3"></div>
          <div class="circle4"></div>
        </div>
        <div class="spinner-container container3">
          <div class="circle1"></div>
          <div class="circle2"></div>
          <div class="circle3"></div>
          <div class="circle4"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
require("static/css/animate.min.css");
require("@static/iconfont/iconfont.css");
import Vconsole from "vconsole";
import common from "./api/common";
export default {
  name: "App",
  data() {
    return {
      loading: false,
      appLoad: false, //app api是否就绪
      user: {}
    };
  },
  created() {},
  methods: {
    setToken() {
      if (this.$route.query.token) {
        localStorage.jzy_token = this.$route.query.token;
      }
      if (this.$route.query.orgId) {
        localStorage.orgId = this.$route.query.orgId;
      }
    }
  },
  beforeCreate() {
    this.$router.onReady(() => {
      this.setToken && this.setToken();
    });
  },
  mounted() {
    if (API_CONFIG.ENV === "0") {
      const vConsole = new Vconsole();
    }
    // // 判断浏览器种类
    // if (
    //   /ip(hone|od|ad).*(micromessenger|mqqbrowser)/i.test(navigator.userAgent)
    // ) {
    //   // 冒泡监听失去焦点事件 blur不会冒泡
    //   window.addEventListener("focusout", function (e) {
    //     // 判断元素
    //     if (e.target && /(input|select|textarea)/i.test(e.target.tagName)) {
    //       document.body.scrollTop = document.body.scrollTop; // 滚动页面
    //     }
    //   });
    // }
  }
};
</script>

<style lang="scss">
#app {
  width: 100%;
  max-width: 10rem;
  min-height: 100%;
  margin: 0 auto;
  overflow: hidden;
  background-color: #ffff;
}
</style>
